
import { mapGetters } from 'vuex'
import blog from '~/mixins/blog'

export default {
  name: 'BlogPageInfo',
  mixins: [blog],
  props: {
    showDate: {
      type: Boolean,
      default: () => false
    },
    showTags: {
      type: Boolean,
      default: () => false
    },
    showAuthor: {
      type: Boolean,
      default: () => false
    },
    showUpdated: {
      type: Boolean,
      default: () => false
    },
    pageMeta: { // Meta data about the page component this is a part of
      type: Object,
      required: true
    },
    resultPage: {
      type: String,
      default: ''
    },
  },
  computed: {
    ...mapGetters({
      getLinkForUuid: 'storyblok/getLinkForUuid'
    }),
    targetPage () {
      return this.getLinkForUuid(this.resultPage)
    },
    targetLink () {
      if (this.targetPage?.slug) {
        return this.$u(this.targetPage?.slug)
      }
      return null
    },
  },
  methods: {
    link (to) {
      return this.targetPage ? `${this.targetLink}#tag=${to}` : to
    }
  }
}
